import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as _ from "lodash";
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html'
})
export class ModalComponent implements OnInit {

    @Input() stepCode: string = "";
    @Input() groupCode: string = "";
    @Input() lineCode: string = "";
    @Input() wizard: any = {};
    //@Output() passEntry: EventEmitter<any> = new EventEmitter();
    userAction: string = "modify";
    controls: any = {};
    controlCodes: any = [];

    constructor(public activeModal: NgbActiveModal,
        private toastrService: ToastrService,
        public translate: TranslateService,
        private modalService: NgbModal) {
    }

    ngOnInit() {
        for (var controlKey in this.wizard.Steps[this.stepCode].ControlGroups[this.groupCode].Controls) {
            this.controls[controlKey] = this.wizard.Steps[this.stepCode].ControlGroups[this.groupCode].Controls[controlKey];// _.cloneDeep();
            this.controls[controlKey].Value = this.wizard.Steps[this.stepCode].ControlGroups[this.groupCode].Lines[this.lineCode].Controls[controlKey].Value;
        }

    }

    passBack() {
        //this.passEntry.emit(this.wizard);
        this.activeModal.close(this.wizard);
    }
    

}
